"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Reference: https://stackoverflow.com/questions/46155/how-to-validate-email-address-in-javascript
/* istanbul ignore next */
function validateEmail(email) {
    /* tslint:disable */
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    /* tslint:enable */
    return re.test(email);
}
exports.validateEmail = validateEmail;
//# sourceMappingURL=EmailValidator.js.map


//////////////////
// WEBPACK FOOTER
// ../player-textbox/build/control/EmailValidator.js
// module id = 603
// module chunks = 0